import _ from 'lodash';
import { findVariantByOptionValues } from 'software_products/redux/utils';

const initialState = {
  priceModifiers: [],
  numberOfUsers: '1',
  selectedOptionIndex: 0,
};

if (Spree.initial_data) {
  _.assign(initialState, Spree.initial_data);
  const { option_types, variants } = Spree.initial_data;

  // If there are not any variants with subscription license span, we set license span to perpetual
  const licenseSpan = variants.find((v) =>
    v.option_values.find((ov) =>
      ov.option_type_name === 'license_span' && ov.name === '1-year'
    )
  ) ? '1-year' : 'perpetual';
  initialState.licenseSpan = licenseSpan;

  const availableNumberOfUsers = option_types
    .find(ot => ot.name === 'num_of_users')
    .option_values
    .filter(ov => _.parseInt(ov.name) <= 10)
    .filter(ov => variants.some(v => v.option_values.some(vov => vov.id === ov.id)))
    .sort((a, b) => _.parseInt(a.name) - _.parseInt(b.name))
    .map(ov => ({ value: _.parseInt(ov.name.split('-')[0]), text: ov.presentation }));

  const availableLicenseSpans = option_types
    .find(ot => ot.name === 'license_span')
    .option_values
    .sort((a, b) => _.parseInt(a.name) - _.parseInt(b.name))
    .map(ov => ({ value: ov.name, text: ov.presentation }));

  const optionValueGroups = [
    {
      licenseType: 'standalone',
      activationMethod: 'computer-locked',
      imageUrl: Spree.image_assets.computer_locked_color,
      description: 'The software can only run on a single computer.'
    },
    {
      licenseType: 'standalone',
      activationMethod: 'usb-dongle',
      imageUrl: Spree.image_assets.usb_dongle_color,
      description: 'Use on any computer by connecting the licensed USB dongle.'
    },
    {
      licenseType: 'network',
      activationMethod: 'computer-locked',
      imageUrl: Spree.image_assets.network,
      description: 'The number of simultaneous users is limited by available license seats.'
    }
  ].filter(({ licenseType, activationMethod }) =>
    variants.some(v =>
      v.option_values.some(ov => ov.option_type_name === 'license-type' && ov.name === licenseType) &&
      v.option_values.some(ov => ov.option_type_name === 'activation_method' && ov.name === activationMethod)
    )
  ).map((group) => {
    const { licenseType, activationMethod, description, imageUrl } = group;

    const licenseTypeOptionType = option_types.find(ot => ot.name === 'license-type');
    const activationMethodOptionType = option_types.find(ot => ot.name === 'activation_method');
    const licenseTypeOptionValue = licenseTypeOptionType.option_values.find(ov => ov.name === licenseType);
    const activationMethodOptionValue = activationMethodOptionType.option_values.find(ov => ov.name === activationMethod);
    const title = licenseTypeOptionValue.presentation;
    const subTitle = activationMethod === 'network' ? '' : activationMethodOptionValue.presentation;
    return {
      licenseTypeId: licenseTypeOptionValue.id,
      licenseTypeName: licenseTypeOptionValue.presentation,
      licenseTypeOptionTypeId: licenseTypeOptionType.id,
      activationMethodId: activationMethodOptionValue.id,
      activationMethodName: activationMethodOptionValue.presentation,
      activationMethodOptionTypeId: activationMethodOptionType.id,
      title,
      subTitle,
      description,
      imageUrl,
    };
  });

  initialState.optionValueGroups = optionValueGroups;
  initialState.availableNumberOfUsers = availableNumberOfUsers;
  initialState.availableLicenseSpans = availableLicenseSpans;
  initialState.selectedVariant = findVariantByOptionValues(initialState);
}

export default initialState;
